import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

const meta = {
    title: 'Attendance',
    breadcrumb: ['Administration', 'Attendance'],
    middleware: [GateKeeperMiddleware],
    // GateKeeperMiddleware's plain-object ability path looks up a Permission record by
    // {action, subject}, derived by parsing the permission name's own text (first word = action,
    // text after " all "/" a "/" an "/" the " = subject) — not by calling the Laravel policy's
    // viewAny() method, and unrelated to it by name. For 'view all attendance scenarios' that
    // derivation is action: 'view all', subject: 'attendance scenarios' (plural).
    ability: { action: 'view all', subject: 'attendance scenarios' },
    denialMessage: "You don't have permission to view the Issue Queue.",
};

export default [
    {
        path: '/admin/attendance/issue-queue',
        name: 'attend-issue-queue',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/administration/AttendIssueQueue.vue'),
        meta,
    },
    {
        path: '/admin/attendance/issue-queue/:requestId(\\d+)',
        name: 'attend-issue-queue-detail',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/administration/AttendIssueQueue.vue'),
        meta,
    },
];
